import m from "react";
import { clsx as f } from "../../../clsx/dist/clsx.js";
import { adaptEventHandlers as i } from "../util/types.js";
import { filterProps as o } from "../util/ReactUtils.js";
function c() {
  return c = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, c.apply(this, arguments);
}
var g = function(r) {
  var t = r.cx, a = r.cy, n = r.r, l = r.className, s = f("recharts-dot", l);
  return t === +t && a === +a && n === +n ? /* @__PURE__ */ m.createElement("circle", c({}, o(r, !1), i(r), {
    className: s,
    cx: t,
    cy: a,
    r: n
  })) : null;
};
export {
  g as Dot
};
